The details of the uploaded candidate that was deleted.

The uploaded candidate profile is available in the `profiles` field.
